import { render, staticRenderFns } from "./FacturasCuadreVenta.vue?vue&type=template&id=20588448&scoped=true&"
import script from "./FacturasCuadreVenta.vue?vue&type=script&lang=js&"
export * from "./FacturasCuadreVenta.vue?vue&type=script&lang=js&"
import style0 from "./FacturasCuadreVenta.vue?vue&type=style&index=0&id=20588448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20588448",
  null
  
)

export default component.exports